import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const OphthalmologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.7856 40C79.7856 61.8153 62.1009 79.5 40.2856 79.5C18.4704 79.5 0.785645 61.8153 0.785645 40C0.785645 18.1848 18.4704 0.5 40.2856 0.5C62.1009 0.5 79.7856 18.1848 79.7856 40Z'
    />
    <g clipPath='url(#clip0_414_11483)'>
      <path
        d='M65.2201 39.6909C60.19 28.509 50.9226 21.009 40.3218 21.009V58.9912C50.9226 58.9912 60.19 51.4911 65.2201 40.3093C65.2438 40.2568 65.2605 40.2021 65.2715 40.1464V39.8538C65.2606 39.7982 65.2438 39.7435 65.2201 39.6909Z'
        fill='#FFAD84'
      />
      <path
        d='M61.795 40.0001C57.5086 28.6475 49.4976 21.009 40.3216 21.009C29.6233 21.009 20.2833 28.6475 15.2856 40.0001C20.2833 51.3526 29.6233 58.9912 40.3216 58.9912C49.4976 58.9912 57.5086 51.3526 61.795 40.0001Z'
        fill='#FFD4A1'
      />
      <path
        d='M65.2716 39.8538C60.2534 31.2924 50.9594 25.5427 40.3218 25.5427V54.4575C50.9594 54.4575 60.2534 48.7078 65.2716 40.1464C65.2906 40.0499 65.2906 39.9504 65.2716 39.8538Z'
        fill='#FE8566'
      />
      <path
        d='M61.795 40.0001C57.5086 31.3577 49.4976 25.5427 40.3216 25.5427C30.8139 25.5427 22.3792 30.1357 17.1117 37.2242C16.0376 37.6878 15.2856 38.756 15.2856 40.0001C15.2856 41.2443 16.0376 42.3125 17.1117 42.776C22.3792 49.8645 30.8139 54.4575 40.3216 54.4575C49.4976 54.4575 57.5086 48.6425 61.795 40.0001Z'
        fill='#FFAD84'
      />
      <path
        d='M53.4421 32.134C49.4831 29.7993 44.9461 28.5652 40.3218 28.5652V51.4351C44.9461 51.4351 49.4832 50.201 53.4421 47.8663C56.7764 45.8999 59.636 43.2018 61.7951 40.0001C59.6361 36.7984 56.7764 34.1003 53.4421 32.134Z'
        fill='#FFFBBE'
      />
      <path
        d='M58.7724 40.0001C56.9173 36.7984 54.4601 34.1002 51.5951 32.134C48.1933 29.7993 44.2949 28.5652 40.3214 28.5652C35.6971 28.5652 31.16 29.7993 27.2011 32.134C23.8668 34.1003 21.0072 36.7984 18.8481 40.0001C21.0072 43.2018 23.8668 45.9 27.2011 47.8663C31.1601 50.201 35.6971 51.4351 40.3214 51.4351C44.295 51.4351 48.1934 50.201 51.5951 47.8663C54.4601 45.9 56.9173 43.2019 58.7724 40.0001Z'
        fill='white'
      />
      <path
        d='M40.3218 28.5652V51.4351C46.6371 51.4351 51.7567 46.3154 51.7567 40.0001C51.7567 33.6848 46.6371 28.5652 40.3218 28.5652Z'
        fill='#01B1BC'
      />
      <path
        d='M48.7341 40.0001C48.7341 33.6848 44.9678 28.5652 40.3217 28.5652C34.0063 28.5652 28.8867 33.6848 28.8867 40.0001C28.8867 46.3154 34.0063 51.4351 40.3217 51.4351C44.9678 51.4351 48.7341 46.3155 48.7341 40.0001Z'
        fill='#3AC7CF'
      />
      <path
        d='M40.3218 34.6101V45.3902C43.2986 45.3902 45.7118 42.977 45.7118 40.0001C45.7118 37.0233 43.2986 34.6101 40.3218 34.6101Z'
        fill='#20335A'
      />
      <path
        d='M42.6893 40.0001C42.6893 37.0233 41.6293 34.6101 40.3217 34.6101C37.3449 34.6101 34.9316 37.0233 34.9316 40.0001C34.9316 42.977 37.3449 45.3902 40.3217 45.3902C41.6293 45.3902 42.6893 42.9771 42.6893 40.0001Z'
        fill='#2B4478'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_11483'>
        <rect width='50' height='50' fill='white' transform='translate(15.2856 15)' />
      </clipPath>
    </defs>
  </svg>
));
OphthalmologyIcon.displayName = 'OphthalmologyIcon';

export default OphthalmologyIcon;
